import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container } from "../Container";
import { Paper } from "../Paper";
import styled from "@emotion/styled";
import { useElementsContext } from "../elementsProvider";
export function RTCTextImage({ colorTexts, colorTitle, image, text, title, typographyTexts, typographyTitle, skin, }) {
    const { isMobile } = useElementsContext();
    const images = JSON.parse(image);
    return (_jsx(Container, { children: _jsxs(PaperStyled, Object.assign({ skin: skin, isDesktop: !isMobile }, { children: [_jsxs(TextContainer, Object.assign({ isDesktop: !isMobile }, { children: [_jsx(Title, Object.assign({ typographyTitle: typographyTitle, colorTitle: colorTitle }, { children: title }), void 0),
                        _jsx(Text, { typographyTexts: typographyTexts, colorTexts: colorTexts, dangerouslySetInnerHTML: { __html: text } }, void 0)] }), void 0),
                _jsx(Image, { skin: skin, src: isMobile ? images.medium : images.large, alt: "Imagen", isDesktop: !isMobile }, void 0)] }), void 0) }, void 0));
}
const PaperStyled = styled(Paper)(({ skin, isDesktop }) => (Object.assign({ display: "grid", gridGap: "2.4rem", padding: "2.4rem", overflow: "hidden" }, (isDesktop
    ? {
        alignItems: "center",
        gridAutoFlow: skin === "1" ? "column" : "",
        gridGap: "4.8rem",
        gridTemplateColumns: "1fr 1fr",
        height: "32rem",
        justifyContent: "center",
        padding: "3.2rem",
    }
    : {}))));
const TextContainer = styled.div(({ isDesktop }) => (Object.assign({ alignItems: "center" }, (isDesktop
    ? {
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxHeight: "25.6rem",
    }
    : {}))));
const Title = styled.h2(({ typographyTitle, colorTitle }) => ({
    color: colorTitle,
    fontFamily: typographyTitle,
    fontSize: "2.4rem",
    marginBottom: "1.6rem",
    marginTop: 0,
}));
const Text = styled.p(({ typographyTexts, colorTexts }) => ({
    color: colorTexts,
    fontFamily: typographyTexts,
    fontSize: "1.4rem",
    margin: 0,
}));
const Image = styled.img(({ skin, isDesktop }) => (Object.assign({ objectFit: "cover", width: "100%" }, (isDesktop
    ? {
        height: "100%",
        gridRow: skin === "2" ? 1 : "",
        maxHeight: "25.2rem",
    }
    : {}))));
//# sourceMappingURL=RTCTextImage.js.map